/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { useEffect, useState } from 'react';

export interface ISignUpDropDownProps {
    id?: string;
    hasFocus?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options: any;
    placeHolderText?: string;
    className: string;
    onChange?: any;
    dependencyBirthReqFlag?: any;
    ariaLabel?: string;
    birthDayDatePatternDescription?: any;
}

export interface ISignUpDropDown {
    key: string;
    AddressItem: INodeProps;
    label: React.ReactNode;
    alert: React.ReactNode;
    input: React.ReactNode;
}
function hideError(elemId: any) {
    var item = document.querySelector(`.ms-sign-up__account-item-${elemId} .ms-sign-up__item-error`);
    if (item) {
        item.classList.remove('show');
        item.innerHTML = '';
        item.setAttribute('aria-hidden', 'true');
    }
}
function showError(elemId: any, message: string) {
    var item = document.querySelector(`.ms-sign-up__account-item-${elemId} .ms-sign-up__item-error`);
    if (item) {
        item.classList.add('show');
        item.innerHTML = message;
        item.setAttribute('aria-hidden', 'false');
    }
}
function updateSAFieldsAttributeFields(
    selfIsReq: boolean,
    selfId: string,
    selfMessage: string,
    otherIsReq: boolean,
    otherId: string,
    otherMessage: string
) {
    window['SA_FIELDS']['AttributeFields'] = window['SA_FIELDS']['AttributeFields'].map((obj: any) => {
        if (obj.ID && obj.ID === selfId) {
            obj.IS_REQ = selfIsReq;
            if (selfIsReq) {
                showError(selfId, selfMessage);
            } else {
                hideError(selfId);
            }
        }
        if (obj.ID && obj.ID === otherId) {
            obj.IS_REQ = otherIsReq;
            if (otherIsReq) {
                showError(otherId, otherMessage);
            } else {
                hideError(otherId);
            }
        }
        return obj;
    });
}

function setIsRequired(
    selfValue: any,
    selfId: any,
    selfMessage: string,
    otherId: any,
    otherMessage: string,
    dependencyBirthReqFlag: boolean
) {
    const otherElement: any = document.getElementById(otherId);
    if (selfValue) {
        if (otherElement && otherElement.value) {
            updateSAFieldsAttributeFields(false, selfId, selfMessage, false, otherId, otherMessage);
            return;
        } else {
            updateSAFieldsAttributeFields(false, selfId, selfMessage, true, otherId, otherMessage);
            return;
        }
    } else if (!selfValue) {
        if (otherElement && otherElement.value) {
            updateSAFieldsAttributeFields(true, selfId, selfMessage, false, otherId, otherMessage);
            return;
        } else {
            if (dependencyBirthReqFlag) {
                updateSAFieldsAttributeFields(true, selfId, selfMessage, true, otherId, otherMessage);
            } else {
                updateSAFieldsAttributeFields(false, selfId, selfMessage, false, otherId, otherMessage);
            }

            return;
        }
    }
}

function patternFinder(monthValue: any) {
    const datePatterns = [
        { month: '', regex: '' },
        { month: '1', regex: '^([1-9]|[12][0-9]|3[01])$' },
        { month: '2', regex: '^([1-9]|[12][0-9]|2[09])$' },
        { month: '3', regex: '^([1-9]|[12][0-9]|3[01])$' },
        { month: '4', regex: '^([1-9]|[12][0-9]|3[00])$' },
        { month: '5', regex: '^([1-9]|[12][0-9]|3[01])$' },
        { month: '6', regex: '^([1-9]|[12][0-9]|3[00])$' },
        { month: '7', regex: '^([1-9]|[12][0-9]|3[01])$' },
        { month: '8', regex: '^([1-9]|[12][0-9]|3[01])$' },
        { month: '9', regex: '^([1-9]|[12][0-9]|3[00])$' },
        { month: '10', regex: '^([1-9]|[12][0-9]|3[01])$' },
        { month: '11', regex: '^([1-9]|[12][0-9]|3[00])$' },
        { month: '12', regex: '^([1-9]|[12][0-9]|3[01])$' }
    ];
    return datePatterns.find((datePattern: any) => {
        return monthValue === datePattern.month;
    });
}
function addBirthDatePattern(pattern: string, birthDayDatePatternDescription: string) {
    window['SA_FIELDS']['AttributeFields'] = window['SA_FIELDS']['AttributeFields'].map((obj: any) => {
        if (obj.ID && obj.ID === 'extension_BirthDate') {
            obj.PAT = pattern;
            obj.PAT_DESC = pattern && birthDayDatePatternDescription ? birthDayDatePatternDescription : '';
        }
        return obj;
    });
}

function validatePatternOnDayAndShowOrHideError(
    monthValue: string,
    dayValue: string,
    patternForDate: any,
    ariaLabel: any,
    dependencyBirthReqFlag: boolean,
    birthDayDatePatternDescription: any
) {
    if (!monthValue && !dayValue) {
        if (dependencyBirthReqFlag) {
            showError('extension_BirthDate', `${ariaLabel} is required`);
        } else {
            hideError('extension_BirthDate');
        }
    } else if (!monthValue && dayValue) {
        hideError('extension_BirthDate');
    } else if (monthValue && !dayValue) {
        showError('extension_BirthDate', `${ariaLabel} is required`);
    } else if (monthValue && dayValue) {
        const regPattern = new RegExp(patternForDate.regex);
        const testResult = regPattern.test(dayValue);
        if (testResult) {
            hideError('extension_BirthDate');
        } else {
            showError('extension_BirthDate', birthDayDatePatternDescription);
        }
    }
}

export const SignUpDayDropDown: React.FC<ISignUpDropDownProps> = ({
    id,
    options,
    placeHolderText,
    className,
    onChange,
    dependencyBirthReqFlag,
    ariaLabel,
    birthDayDatePatternDescription
}) => {
    const [textValue, setValue] = useState('');
    const [patternValue, setPattern] = useState('');
    const [dayOptions, setDayOptions] = useState<any>([]);
    const [month, setMonth] = useState<any>('');
    const daysAccordingToMonth = {
        1: 31,
        2: 29,
        3: 31,
        4: 30,
        5: 31,
        6: 30,
        7: 31,
        8: 31,
        9: 30,
        10: 31,
        11: 30,
        12: 31
    };

    useEffect(() => {
        window.addEventListener('BirthMonthChanged', (event: any) => {
            if (event.detail) {
                const monthValue = event.detail.month ? event.detail.month : '';
                const dayElement: any = document.getElementById('extension_BirthDate');
                // dayElement.value = '';
                const dayValue: any = '';
                // if (dayElement) {
                //     dayValue = dayElement.value;
                // }
                if (dayElement) {
                    dayElement.value = '';
                    // dayValue = dayElement.value;
                }
                setValue('');
                const options = Array.from(new Array(daysAccordingToMonth[monthValue]), (day, index) => index + 1);
                setDayOptions(options);
                const patternForDate: any = patternFinder(monthValue);
                setMonth(monthValue);
                addBirthDatePattern(patternForDate.regex, birthDayDatePatternDescription);
                setPattern(patternForDate.regex);
                validatePatternOnDayAndShowOrHideError(
                    monthValue,
                    dayValue,
                    patternForDate,
                    ariaLabel,
                    dependencyBirthReqFlag,
                    birthDayDatePatternDescription
                );
            }
        });
    }, []);

    const onSelectChange = (e: any) => {
        setValue(e.target.value);
        const monthElement: any = document.getElementById('extension_BirthMonth');
        setIsRequired(
            e.target.value,
            'extension_BirthDate',
            `${ariaLabel} is required`,
            'extension_BirthMonth',
            'Month is required',
            dependencyBirthReqFlag
        );
        if (monthElement) {
            const monthValue = monthElement.value;
            const patternForDate: any = patternFinder(monthValue);
            addBirthDatePattern(patternForDate.regex, birthDayDatePatternDescription);
            setPattern(patternForDate.regex);
            validatePatternOnDayAndShowOrHideError(
                monthValue,
                e.target.value,
                patternForDate,
                ariaLabel,
                dependencyBirthReqFlag,
                birthDayDatePatternDescription
            );
        }
    };
    return (
        <>
            <select
                id={placeHolderText}
                className={`${className}-input ${className}-${id}`}
                onChange={onSelectChange}
                aria-label={ariaLabel ? ariaLabel : ''}
                disabled={month === ''}
            >
                <option value={''} selected={textValue === ''}>
                    {placeHolderText}
                </option>
                {dayOptions.map((option: any, index: number) => {
                    return (
                        <option value={option} key={index}>
                            {option}
                        </option>
                    );
                })}
            </select>
            <input
                id={id}
                pattern={patternValue !== '' ? patternValue : undefined}
                value={textValue}
                style={{ display: 'none' }}
                aria-label={ariaLabel ? ariaLabel : ''}
                aria-required='true'
            />
        </>
    );
};

export const SignUpMonthDropDown: React.FC<ISignUpDropDownProps> = ({
    id,
    options,
    placeHolderText,
    className,
    onChange,
    dependencyBirthReqFlag,
    ariaLabel
}) => {
    const [textValue, setValue] = useState('');
    const onSelectChange = (e: any) => {
        setValue(e.target.value);
        setIsRequired(
            e.target.value,
            'extension_BirthMonth',
            `${ariaLabel} is required`,
            'extension_BirthDate',
            `Birth date is required`,
            dependencyBirthReqFlag
        );
        window.dispatchEvent(new CustomEvent('BirthMonthChanged', { detail: { month: e.target.value } }));
    };
    return (
        <>
            <select
                id={placeHolderText}
                className={`${className}-input ${className}-${id}`}
                onChange={onSelectChange}
                aria-label={ariaLabel}
            >
                <option value={''} selected={textValue === ''}>
                    {placeHolderText}
                </option>
                {options.map((option: any, index: number) => {
                    return (
                        <option value={option.value} key={index}>
                            {option.label}
                        </option>
                    );
                })}
            </select>
            <input id={id} value={textValue} style={{ display: 'none' }} aria-label={ariaLabel} />
        </>
    );
};
export const SignUpStateDropDown: React.FC<any> = ({
    id,
    options,
    placeHolderText,
    className,
    ariaLabel,
    defaultValue,
    showStateField
}) => {
    const [textValue, setValue] = useState('');
    useEffect(() => {
        if (defaultValue) {
            setValue(defaultValue.value ?? '');
        }
    }, [defaultValue.value]);
    return (
        <>
            {showStateField && (
                <select
                    id={placeHolderText}
                    className={`${className}-input ${className}-${id}`}
                    onChange={e => setValue(e.target.value)}
                    aria-label={ariaLabel}
                    required={true}
                >
                    <option value={''} selected={textValue === ''} disabled>
                        {placeHolderText}
                    </option>
                    {options.map((option: any, index: number) => {
                        return (
                            <option selected={textValue === option.value} value={option.value} key={index}>
                                {option.label}
                            </option>
                        );
                    })}
                </select>
            )}
            <input id={id} value={textValue} style={{ display: 'none' }} aria-label={ariaLabel} />
        </>
    );
};
